import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledAssetSentimentBar,
  StyledBallLeft,
  StyledBallRight,
  StyledMarketSentimentBar,
  StyledSentimentContainer,
  StyledSentimentLabel,
  StyledSentimentProgressBar,
  StyledTooltipBubble,
  StyledTooltipLabel,
  StyledTooltipsRow,
} from '../styled';
import { SentimentBarProps } from '../types';

/**
 * Sentiment Bar Component
 * Displays sentiment vs market section with dual-sided progress bar
 */
export const SentimentBar: FC<SentimentBarProps> = ({
  sentimentData,
  barWidths,
}) => {
  const { t } = useTranslation('communityStats');

  return (
    <StyledSentimentContainer>
      <StyledSentimentLabel>
        {t('pinnedAssetOverview.sentiment.title')}
      </StyledSentimentLabel>

      <StyledTooltipsRow>
        <StyledTooltipBubble>
          <StyledTooltipLabel>
            <StyledBallLeft />
            {t('pinnedAssetOverview.sentiment.asset')} (
            {sentimentData.assetSentimentPercent}%)
          </StyledTooltipLabel>
        </StyledTooltipBubble>

        <StyledTooltipBubble>
          <StyledTooltipLabel>
            <StyledBallRight />
            {t('pinnedAssetOverview.sentiment.market')} (
            {sentimentData.marketSentimentPercent}%)
          </StyledTooltipLabel>
        </StyledTooltipBubble>
      </StyledTooltipsRow>

      <StyledSentimentProgressBar>
        <StyledAssetSentimentBar width={barWidths.asset} />
        <StyledMarketSentimentBar width={barWidths.market} />
      </StyledSentimentProgressBar>
    </StyledSentimentContainer>
  );
};
